import { useEffect, useMemo, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import axios from "../../api/axios";

const MobileSso = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [error, setError] = useState("");

  const bridge = useMemo(() => searchParams.get("bridge") || "", [searchParams]);
  const hashParams = useMemo(() => {
    const hash = window.location.hash || "";
    const raw = hash.startsWith("#") ? hash.slice(1) : hash;
    return new URLSearchParams(raw);
  }, []);

  const next = useMemo(() => {
    const valueFromQuery = searchParams.get("next");
    const valueFromHash = hashParams.get("next");
    const value = valueFromQuery || valueFromHash || "/become-employer";
    if (value.startsWith("/") && !value.startsWith("//")) return value;
    return "/become-employer";
  }, [searchParams, hashParams]);

  const tokenFromHash = useMemo(() => {
    return hashParams.get("token") || "";
  }, [hashParams]);

  useEffect(() => {
    let mounted = true;

    const consumeBridge = async () => {
      try {
        let user = null;
        let token = null;

        if (bridge) {
          const response = await axios.post("/users/web-sso/consume", { bridge });
          user = response?.data?.user;
          token = response?.data?.token;
        } else if (tokenFromHash) {
          token = tokenFromHash;
          localStorage.setItem("x-access-token", token);
          const profileRes = await axios.get("/users/profile");
          user = profileRes?.data?.user;
        } else {
          throw new Error("Missing secure login token");
        }

        if (!user || !token) {
          throw new Error("Invalid SSO response");
        }

        localStorage.setItem("auth", JSON.stringify(user));
        localStorage.setItem("x-access-token", token);

        // Full reload ensures auth context is re-initialized immediately.
        window.location.replace(next);
      } catch (e) {
        if (!mounted) return;
        setError("Automatic login failed. Please sign in on website.");
        setTimeout(() => {
          navigate("/sign-in", { replace: true });
        }, 1200);
      }
    };

    consumeBridge();

    return () => {
      mounted = false;
    };
  }, [bridge, tokenFromHash, next, navigate]);

  return (
    <div
      className="d-flex flex-column justify-content-center align-items-center"
      style={{ minHeight: "60vh", textAlign: "center", padding: "16px" }}
    >
      <h5 style={{ marginBottom: "10px" }}>Signing you in...</h5>
      <p style={{ color: "#6c757d", marginBottom: 0 }}>
        {error || "Please wait while we securely log you in from the mobile app."}
      </p>
    </div>
  );
};

export default MobileSso;
